import { render, staticRenderFns } from "./CustomBrandingColours.vue?vue&type=template&id=97f0899e&"
import script from "./CustomBrandingColours.vue?vue&type=script&lang=js&"
export * from "./CustomBrandingColours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports